import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerFeatureComponent } from './ect-feature.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerDetailComponent } from './customer-detail/customer-detail.component';
import { ConfigurationDetailComponent } from './configuration-detail/configuration-detail.component';
import { ConfigurationListComponent } from './configuration-list/configuration-list.component';
import { ParameterDetailComponent } from './parameter-detail/parameter-detail.component';
import { ParameterListComponent } from './parameter-list/parameter-list.component';
import { AdministrationComponent } from './administration/administration.component';
import { EctUserGuard } from './services/ect-user.guard';
import { EctAdminGuard } from './services/ect-admin.guard';
import {StackDetailComponent} from './stack-detail/stack-detail.component';
import { OktaConfigurationComponent } from './okta-configuration/okta-configuration.component';
import { oktaIdmCanActivate } from '../shared/oktaIdmCanActivate';


export function onAuthRequired({ oktaAuth, router }) {
  // Redirect the user to your custom login page
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'ect',
    component: CustomerFeatureComponent,
    canActivate: [oktaIdmCanActivate],
    data: {
      onAuthRequired
    },
    children: [
      {
        path: 'customers',
        component: CustomerListComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'customers/detail/:id',
        component: CustomerDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'customers/new',
        component: CustomerDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'customers/delete',
        component: CustomerDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'configurations',
        component: ConfigurationListComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'configurations/detail/:id',
        component: ConfigurationDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'stacks/detail',
        component: StackDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'customers/detail/:customerId/newConfiguration',
        component: ConfigurationDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'customers/detail/oktaConfiguration/:customerName/:crmId/:editable',
        component: OktaConfigurationComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired
        }
      },
      {
        path: 'parameters',
        component: ParameterListComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'parameters/detail/:id',
        component: ParameterDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired

        }
      },
      {
        path: 'configurations/detail/:configurationId/newParameter',
        component: ParameterDetailComponent,
        canActivate: [oktaIdmCanActivate, EctUserGuard],
        data: {
          onAuthRequired
        }
      },{
        path: 'administration',
        component: AdministrationComponent,
        canActivate: [oktaIdmCanActivate, EctAdminGuard],
        data: {
          onAuthRequired

        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerFeatureRoutingModule { }
